export const DATADESC = {
  title: "DataDesc",
  github: "https://github.com/FZJ-IEK3-VSA/DataDesc",
  email: "info@datadesc.org",
  schema: {
    jsonSchema: "https://datadesc.org/schema/datadesc_technical_schema.json",
    jsonld: "https://datadesc.org/schema/datadesc.jsonld",
    version: "1.3",
  },
};
